import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import Application from "../Components/admin/StateContext/Application";

const ProtectedRoute = () => {
    const { Usermenu } = useContext(Application);
    const [allowed, setAllowed] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const checkAccess = async () => {
            try {
                const token = localStorage.getItem("Token");

                if (!token) {
                    alert("Session expired. Please login again.");
                    navigate("/AdminLogin", { replace: true });
                    return;
                }

                const data = await Usermenu();
                const menuArray = Array.isArray(data?.result) ? data.result : [];

                const hasAccess = menuArray.some(
                    (item) => item.Link === location.pathname
                );

                if (!hasAccess) {
                    alert("You are not allowed to access this page 🚫");
                    navigate("/AdminDashboard", { replace: true });
                } else {
                    setAllowed(true);
                }

            } catch (err) {
                console.error(err);
                alert("Something went wrong");
                navigate("/AdminDashboard", { replace: true });
            }
        };

        checkAccess();
    }, [location.pathname]);

    // ⛔ Prevent rendering anything until check finishes
    if (allowed !== true) return null;

    return <Outlet />;
};

export default ProtectedRoute;